<template>
  <div class="border-gray-400 border-solid border-t h-0 mx-0 my-2 overflow-hidden" />
</template>
